module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/14u3pBy/tc-custom/9781788487474.jpg?1705766095375",
      "alt": "This image is the cover for the book Vi and Vincent the Jibber Jabbers"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Vi and Vincent the Jibber Jabbers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Amy’s off to get a vaccine today but her big brother isn’t impressed, as he wanted to stay home and play. But suddenly the vaccine starts talking to him – and him alone. Join us for a stimulating and enthralling journey to discover just how vaccines work and how they can keep so many of us safe and healthy.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Celia Brown\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Celia Brown is a Professor of Medical Education at Warwick Medical School. One of her favourite activities is reading to her son, hoping to inspire a love of reading. The hours she spends reading to him inspired her to take up the challenge of authoring a book herself. Celia is a STEM (Science, Technology, Engineering and Mathematics) Ambassador, leading outreach events in local schools and at the University of Warwick to share her other passion – mathematics and statistics. Celia is also a keen cyclist, getting inspiration for her work while out in the countryside.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0